export const LoadingComponent = () => {
    return (
        <div className="d-flex justify-content-center align-items-center loading-overlay">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}


export const DotLoading = () => {
    return (
        <div className="container-dot"><div className="dot" /></div>
    )
}

export const Loader = () => {
    return (
        <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    )
}